<template>
  <p>这是smartshare外链创建界面</p>
</template>

<script>
export default {

}
</script>

<style>

</style>
